<template>
    <v-card class="editor pa-0 ma-0" :disabled="editorDisabled" elevation='0'>
        <v-text-field
            color="success"
            label="Main input"
        ></v-text-field>
    </v-card>
</template>

<script>
    import EditorState from './EditorState.js';

    export default {
        name:'DefaultEditor',
        prop:['context'],
        data () {
            return {
                billData:{
                    billId:-1,  //-1表示新数据
                },
                editorState:EditorState.BROWSING,
            }
        },
        computed:{
            editorDisabled(){
                console.log("editorDisabled");
                return (this.editorState!=EditorState.EDITING);
            },
        },
        methods:{
            getContext(){
                return this.context;
            },
            getBillData(){
                return this.billData;
            },
            getBillId(){
                return this.billData.billId;
            },
            
            clear(){
                this.billData={};
            },

            //--need implement--
            setState(state){
                this.editorState = state;
            },
            //回调注意传入单据数据信息
            loadData(billInfo,loadRemote,loadSuccessCallback,loadFailCallback){
                this.clear();

                let bill=billInfo;
               
                //远程加载
                bill=billInfo;
                               
                loadSuccessCallback(bill);
            },
            //回调注意传入单据数据信息,建议所有持久化服务程序，执行完后在服务端立即执行查询并返回，节省一次调用
            saveData(saveSuccessCallback,saveFailCallback){
                let bill={};

                saveSuccessCallback(bill);
            },
            deleteData(deleteSuccessCallback,deleteFailCallback){
                let bill={};

                deleteSuccessCallback(bill);
            },
            auditData(auditSuccessCallback,auditFailCallback){
                let bill={};

                auditSuccessCallback(bill);
            },
            cancelAuditData(cancelAuditSuccessCallback,cancelAuditFailCallback){
                let bill={};

                cancelAuditSuccessCallback(bill);
            },
            voidData(voidSuccessCallback,voidFailCallback){
                let bill={};

                voidSuccessCallback(bill);
            },
            cancelVoidData(cancelVoidSuccessCallback,cancelVoidFailCallback){
                let bill={};

                cancelVoidSuccessCallback(bill);
            },
            putOnData(putOnSuccessCallback,putOnFailCallback){
                let bill={};

                putOnSuccessCallback(bill);
            },
            withdrawData(withdrawSuccessCallback,withdrawFailCallback){
                let bill={};

                withdrawSuccessCallback(bill);
            },
            stopData(stopSuccessCallback,stopFailCallback){
                let bill={};

                stopSuccessCallback(bill);
            },
            restoreData(restoreSuccessCallback,restoreFailCallback){
                let bill={};
                restoreSuccessCallback(bill);
            },

            //用于指示按钮可用性
            canEdit(){
                return true;    
            },
            canDelete(){
                return true;
            },
            
            canSave(){
                return true;
            },
            canAudit(){
                return true;
            },
            canCancelAudit(){
                return true;
            },
            canVoid(){
                return true;
            },
            canCancelVoid(){
                return true;
            },
            canPutOn(){
                return true;
            },
            canWithdraw(){
                return true;
            },

            canRestore(){
                return true;
            },
            canStop(){
                return true;
            },

        }
    }
</script>

</<style>
</style>
